import { useQuery } from '@tanstack/react-query';
import { clientTeamService } from '@/services/clientTeamService';
import { useAuth } from '@/hooks/useAuth';

export function useClientTeamMembership() {
  const { user } = useAuth();

  const { data: memberships, isLoading } = useQuery({
    queryKey: ['client-team-memberships', user?.id],
    queryFn: () => clientTeamService.getCurrentUserMemberships(),
    enabled: !!user,
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });

  // Check if user is a client (not just team member)
  const isClient = memberships?.some((m: any) => m.role === 'client') ?? false;

  return {
    hasTeamMemberships: (memberships?.length ?? 0) > 0,
    isClient,
    loading: isLoading,
    memberships: memberships || [],
  };
}
